import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=fb515a70&scoped=true&"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTreeviewNode.vue?vue&type=style&index=0&id=fb515a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb515a70",
  null
  
)

export default component.exports